import { useMemo } from 'react';

import { RootState, Utilities } from 'core';
import { useSelector } from 'react-redux';

import { useRouterCurrent } from './hooks';
import { ShippingModel, ShippingModelProductNotFound } from '../SectionBuilder/sections';

const SectionBuilder = () => {
  const { isMainHeader = false } = useRouterCurrent();
  const cartStatus: RootState['cart']['fetch']['status'] = useSelector(
    (state: RootState) => state.cart.fetch.status,
  );

  const shippingModel = useMemo(() => {
    return cartStatus === Utilities.STATUS.SUCCESS ? <ShippingModel /> : null;
  }, [cartStatus]);

  if (!isMainHeader) {
    return <></>;
  }

  return (
    <>
      {shippingModel}
      <ShippingModelProductNotFound />
    </>
  );
};

export default SectionBuilder;
